import { useEffect, useState } from "react";

type IconProps = {
  className?: string;
  fill?: string;
};

const SwitchIcon = ({ className, fill }: IconProps) => {
  const [_class, setClass] = useState(className);

  useEffect(() => {
    let classStr = className || "";
    if (!classStr.includes("w-")) {
      classStr += " w-5";
    }
    if (!classStr.includes("h-")) {
      classStr += " h-5";
    }

    setClass(classStr);
  }, [className]);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      strokeWidth="0"
      stroke={fill}
      className={_class}
    >
      <path
        d="M10.6867 4.50007H12.3742V16.0795L9.95943 13.6647L9.16406 14.4601L12.539 17.835C12.7589 18.055 13.1144 18.055 13.3344 17.835L16.7093 14.4601L15.914 13.6647L13.4992 16.0795V3.93758C13.4992 3.62652 13.2477 3.37509 12.9367 3.37509H10.6867V4.50007Z"
        fill="#4D4D4D"
      />
      <path
        d="M4.66401 0.165037L1.28906 3.53998L2.08443 4.33535L4.4992 1.92057L4.4992 14.0625C4.4992 14.373 4.75063 14.625 5.06169 14.625H7.31166V13.5H5.62418L5.62418 1.92057L8.03896 4.33535L8.83432 3.53998L5.45937 0.165037C5.23944 -0.0548964 4.88394 -0.0548964 4.66401 0.165037Z"
        fill="#4D4D4D"
      />
    </svg>
  );
};

export default SwitchIcon;
